import React, { useEffect, useRef, useState } from 'react';
import { prefersReducedMotion } from './salesUtils';

const DURATION_MS = 250; // kept under 300ms per the UX bar

// Tweens a number from its previous value to the new one. The first render and
// prefers-reduced-motion users get the final value immediately.
const AnimatedNumber = ({ value, format }) => {
  const [shown, setShown] = useState(value);
  const prev = useRef(value);

  useEffect(() => {
    const start = prev.current;
    prev.current = value;
    if (start === value || prefersReducedMotion() || typeof window.requestAnimationFrame !== 'function') {
      setShown(value);
      return undefined;
    }
    let frame;
    const t0 = performance.now();
    const step = (t) => {
      const k = Math.min(1, (t - t0) / DURATION_MS);
      const eased = 1 - (1 - k) * (1 - k);
      setShown(start + (value - start) * eased);
      if (k < 1) frame = window.requestAnimationFrame(step);
    };
    frame = window.requestAnimationFrame(step);
    return () => window.cancelAnimationFrame(frame);
  }, [value]);

  return <span className="tabular-nums">{format(shown)}</span>;
};

export default AnimatedNumber;
